import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { PATH_AUTH } from "routes/paths";
import _ from "lodash";

const AuthMiddleware = ({ children }) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const authData = JSON.parse(localStorage.getItem("auth"));

    if (!authData?.token) {
      navigate(PATH_AUTH.login);
      return;
    }

    // Set up axios interceptor only once when the component mounts
    const interceptor = axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response?.data?.status === 401) {
          localStorage.removeItem("auth");
          navigate(PATH_AUTH.login);
        }
        return Promise.reject(error);
      }
    );

    setIsAuthenticated(true);

    // Clean up interceptor when the component unmounts
    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [navigate]);

  // Only render children if authenticated
  return isAuthenticated ? <Box>{children}</Box> : null;
};

export default AuthMiddleware;
